export const gradeFromScore = (t) => {
  const v = Number(t) || 0;
  if (v >= 75) return { key: "excellent", label: "Отлично", solid: "#16A34A", text: "#15803D", bg: "#DCFCE7" };
  if (v >= 50) return { key: "good", label: "Хорошо", solid: "#84CC16", text: "#4D7C0F", bg: "#ECFCCB" };
  if (v >= 25) return { key: "bad", label: "В меру", solid: "#F97316", text: "#C2410C", bg: "#FFEDD5" };
  return { key: "awful", label: "Не рекомендуем", solid: "#DC2626", text: "#B91C1C", bg: "#FEE2E2" };
};

export const GRADE_META = {
  excellent: { label: "Отлично", solid: "#16A34A", text: "#15803D" },
  good: { label: "Хорошо", solid: "#84CC16", text: "#4D7C0F" },
  bad: { label: "В меру", solid: "#F97316", text: "#C2410C" },
  awful: { label: "Не рекомендуем", solid: "#DC2626", text: "#B91C1C" },
};

export const STATUS_COLOR = { good: "#16A34A", medium: "#F97316", bad: "#DC2626" };

export const relTime = (iso, t) => {
  if (!iso) return "";
  const tr = t || ((k) => k);
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return tr("time.now");
  if (diff < 3600) return `${Math.floor(diff / 60)} ${tr("time.min")}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ${tr("time.h")}`;
  const days = Math.floor(diff / 86400);
  if (days === 1) return tr("time.yesterday");
  if (days < 7) return `${days} ${tr("time.days")}`;
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
};
